import React from "react";

const Footer = ({ theme = "light" }) => {
  const isLight = theme === "light";
  
  const styles = {
    container: {
      borderTop: `1px solid ${isLight ? "rgba(61, 107, 74, 0.15)" : "rgba(255, 255, 255, 0.1)"}`,
      backgroundColor: isLight ? "#F6F1E9" : "#0A0A0A"
    },
    text: {
      color: isLight ? "#6B756D" : "rgba(255, 255, 255, 0.7)"
    },
    link: {
      color: isLight ? "#3D6B4A" : "#3D6B4A"
    }
  };

  return (
    <footer style={styles.container}>
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6 text-sm" style={styles.text}>
            <a 
              href="/support" 
              className="hover:underline"
              style={styles.link}
            >
              Support
            </a>
            <a 
              href="/privacy" 
              className="hover:underline"
              style={styles.text}
            >
              {isLight ? "Confidentialité" : "Privacy"}
            </a>
            <a 
              href="/terms" 
              className="hover:underline"
              style={styles.text}
            >
              {isLight ? "CGU" : "Terms"}
            </a>
          </div>
          
          <div className="text-sm" style={styles.text}>
            © 2026 NutriNori
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
